import { render, staticRenderFns } from "./GvntAdd.vue?vue&type=template&id=3513945b&scoped=true&"
import script from "./GvntAdd.vue?vue&type=script&lang=js&"
export * from "./GvntAdd.vue?vue&type=script&lang=js&"
import style0 from "./GvntAdd.vue?vue&type=style&index=0&id=3513945b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513945b",
  null
  
)

export default component.exports